module.exports = __webpack_public_path__ + "img/Weapon_188.12c95709.png";